/**
 * Sport File Extensions
 *
 * Some sports use non-SVG team logo files.
 * This module provides a lookup for the correct file extension.
 */

/** Sports that use a non-default file extension for team logos */
export const SPORT_FILE_EXTENSIONS: Record<string, string> = {
  nba: 'png',
  ncaamb: 'png',
};

/** Default file extension for team logos */
export const DEFAULT_FILE_EXTENSION = 'svg';

/**
 * Get the file extension for team logos of a given sport.
 * @param sport - Sport code (case-insensitive)
 * @returns File extension without dot, e.g. 'svg' or 'png'
 */
export function getFileExtForSport(sport: string): string {
  return SPORT_FILE_EXTENSIONS[sport.toLowerCase()] || DEFAULT_FILE_EXTENSION;
}
